import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiService } from '../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ApiUrl } from '../services/apiUrl';
import * as moment from 'moment';
import { BaseChartDirective } from 'ng2-charts';
import { ChartConfiguration, ChartType } from 'chart.js';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.scss'],
})
export class GraphComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  managerId = localStorage.getItem('managerId');
  role: any = localStorage.getItem('role');
  chartOptions: any;
  series: any;
  chart1: any;
  title: any;
  timeout: any = null;
  word: any = '';
  startDate: any = '';
  endDate: any = '';
  date: any;
  storeId: any;
  counts: any[] = [];
  dates: any[] = [];
  storeData: any;
  page: any;
  ManagerStoreData: any;
  displayChart = false;

  // Chart.js configuration
  public lineChartData: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'Store status ok',
        backgroundColor: 'rgba(77,83,96,0.2)',
        borderColor: 'rgba(77,83,96,1)',
        pointBackgroundColor: 'rgba(77,83,96,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(77,83,96,1)',
        fill: 'origin',
      }
    ],
    labels: []
  };

  public lineChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    scales: {
      y: {
        min: 0
      }
    },
    plugins: {
      legend: {
        display: true,
      }
    }
  };

  public lineChartType: ChartType = 'line';

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private service: ApiService
  ) {}

  ngOnInit() {
    if (this.role == 'admin') {
      this.getStoreData();
      this.graphChart();
    } else {
      this.getManagerStoreData();
      this.graphChart();
    }
  }

  graphChart() {
    if (this.role == 'manager' && this.managerId) {
      this.spinner.show();
      this.service
        .getRequest(
          `${ApiUrl.managerStoreDoorGraph}${this.managerId}` +
            `?startDate=` +
            this.startDate +
            `&endDate=` +
            this.endDate
        )
        .subscribe(
          (res: any) => {
            if (res.response.data) {
              this.spinner.hide();
            }
            this.counts = res.response.data.map((item: any) => item?.okCount);

            this.dates = res.response.data.map(
              (item: any) => item?.statusCheckTime
            );
            
            const formattedDates = this.dates.map((dateString: string) => {
              const date = new Date(dateString);
              const formattedDate = `${date
                .toISOString()
                .slice(0, 16)
                .replace('T', ' ')}`;
              return formattedDate;
            });

            // Update Chart.js data
            this.lineChartData.datasets[0].data = this.counts;
            this.lineChartData.labels = formattedDates;
            
            // Save traditional chart options for displaying in template
            this.chartOptions = {
              series: [
                {
                  name: 'Store status ok',
                  data: this.counts,
                },
              ],
              chart: {
                height: 350,
                type: 'line',
                zoom: {
                  enabled: false,
                },
                toolbar: {
                  show: false,
                },
              },
              dataLabels: {
                enabled: true,
              },
              stroke: {
                curve: 'smooth',
              },
              xaxis: {
                categories: formattedDates,
              },
              yaxis: {
                min: 0,
              },
            };
            
            this.displayChart = true;
            this.updateChart();
          },
          (err) => {
            this.spinner.hide();
          }
        );
    } else {
      this.spinner.show();
      this.service
        .getRequest(
          `${ApiUrl.storeDoorGraph}` +
            `?startDate=` +
            this.startDate +
            `&endDate=` +
            this.endDate
        )
        .subscribe(
          (res: any) => {
            if (res.response.data) {
              this.spinner.hide();
            }
            this.counts = res.response.data.map((item: any) => item?.okCount);

            this.dates = res.response.data.map(
              (item: any) => item?.statusCheckTime
            );
            const formattedDates = this.dates.map((dateString: string) => {
              const date = new Date(dateString);
              const formattedDate = `${date
                .toISOString()
                .slice(0, 16)
                .replace('T', ' ')}`;
              return formattedDate;
            });

            // Update Chart.js data
            this.lineChartData.datasets[0].data = this.counts;
            this.lineChartData.labels = formattedDates;
            
            // Save traditional chart options for displaying in template
            this.chartOptions = {
              series: [
                {
                  name: 'Store status ok',
                  data: this.counts,
                },
              ],
              chart: {
                height: 350,
                type: 'line',
                zoom: {
                  enabled: false,
                },
                toolbar: {
                  show: false,
                },
              },
              dataLabels: {
                enabled: true,
              },
              stroke: {
                curve: 'smooth',
              },
              xaxis: {
                categories: formattedDates,
              },
              yaxis: {
                min: 0,
              },
            };
            
            this.displayChart = true;
            this.updateChart();
          },
          (err) => {
            this.spinner.hide();
          }
        );
    }
  }

  updateChart() {
    if (this.chart) {
      this.chart.update();
    }
  }

  onFilterKeySearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      // this.showList();
    }, 1000);
  }
  
  clearDate() {
    this.startDate = '';
    this.endDate = '';
    this.date = '';
    this.graphChart();
  }
  
  updateRangeDate(event: any) {
    if (event.start && event.end) {
      this.startDate = moment(event.start).startOf('day').format('YYYY-MM-DD');
      this.endDate = moment(event.end).endOf('day').format('YYYY-MM-DD');
      this.graphChart();
    }
  }
  
  getStoreData() {
    this.spinner.show();
    this.service.getRequest(ApiUrl.storeList).subscribe(
      (res: any) => {
        this.storeData = res.response?.data?.storeCount;
        this.spinner.hide();
      },
      (err) => {
        this.spinner.hide();
      }
    );
  }
  
  getManagerStoreData() {
    this.spinner.show();
    this.service
      .getRequest(
        `${ApiUrl.storeListById}${this.managerId}` +
          `?page=` +
          this.page +
          `&word=` +
          this.word
      )
      .subscribe((res: any) => {
        this.ManagerStoreData = res.response?.data;
        this.spinner.hide();
      });
  }
}
